export const updateOrgConfigurationsStart = (state, payload) => {
    return {
        ...state,
        updateOrgConfigurationsApi: {
            ...state.updateOrgConfigurationsApi,
            isProcessing: true,
            error: false,
        }


    };
};

export const updateOrgConfigurationsSuccess = (state, payload) => {
    return {
        ...state,
        updateOrgConfigurationsApi: {
            ...state.updateOrgConfigurationsApi,
            isProcessing: false,
            error: false,
        }

    };
};

export const updateOrgConfigurationsFail = (state, payload) => {
    return {
        ...state,
        updateOrgConfigurationsApi: {
            ...state.updateOrgConfigurationsApi,
            isProcessing: false,
            error: true,
        }

    };
};
